import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    borderRadius: 24,
    backgroundColor: '#EBEBEB',
    width: 500,
    padding: 30,
    alignItems: 'center',
  },

  title: {
    fontSize: 35,
    color: '#1F647A',

    fontFamily: 'Raleway_700Bold',
  },

  description: {
    fontSize: 20,
    color: '#1F647A',

    fontFamily: 'Raleway_400Regular',
  },

  button: {
    width: '100%',
    borderWidth: 2,
    borderColor: '#D9D9D9',
    backgroundColor: '#F0F0F0',
    borderRadius: 8,
    height: 50,
    padding: 12,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 18,
  },

  textLetter: {
    fontSize: 20,
    color: '#1F647A',
    marginRight: 10,
    fontFamily: 'Montserrat_700Bold',
  },

  textAnswers: {
    fontSize: 18,

    fontFamily: 'Montserrat_400Regular',
  },

  buttonBack: {
    height: 50,
    width: 200,
    borderRadius: 8,
    backgroundColor: '#1F647A',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },

  textBack: {
    fontSize: 20,
    color: '#ffffff',
    fontFamily: 'Raleway_400Regular',
  },

  input: {
    height: 50,
    width: '80%',
    borderWidth: 1.5,
    borderColor: '#1F647A',
    borderRadius: 4,
    marginBottom: 20,
    fontFamily: 'Raleway_400Regular',
    paddingLeft: 15,
  },
});
